(() => {
  if (window.__herDadNewsletterFormsLoaded) return;
  window.__herDadNewsletterFormsLoaded = true;

  const config = document.currentScript;
  const subscribedKey = 'her-dad-newsletter-signed-up';
  const positionKey = 'her-dad-newsletter-return-position';
  const dialog = document.getElementById('HdNewsletterPopup');
  const knownSubscriber = config?.dataset.knownSubscriber === 'true';
  const pastOrders = config?.dataset.pastOrders === 'true';
  const inlineResults = [...document.querySelectorAll('[data-hd-newsletter-inline-result]')];
  const popupResult = dialog?.querySelector('[data-hd-newsletter-result]')?.dataset.hdNewsletterResult;
  const success = popupResult === 'success' || inlineResults.some((node) => node.dataset.hdNewsletterInlineResult === 'success');

  const read = (kind, key) => {
    try { return window[kind].getItem(key); } catch { return null; }
  };

  const write = (kind, key, value) => {
    try { window[kind].setItem(key, value); } catch {}
  };

  if (knownSubscriber || success) write('localStorage', subscribedKey, String(Date.now()));
  document.documentElement.classList.toggle('hd-newsletter-subscribed', knownSubscriber || Boolean(read('localStorage', subscribedKey)));
  document.documentElement.classList.toggle('hd-newsletter-returning-subscriber', knownSubscriber && pastOrders);

  let pending;
  try { pending = JSON.parse(read('sessionStorage', positionKey) || 'null'); } catch {}
  const fresh = pending && Date.now() - pending.at >= 0 && Date.now() - pending.at < 20 * 60 * 1000;
  const matchingPage = fresh && pending.path === location.pathname;

  if (matchingPage) {
    if (pending.source === 'popup' && ['success', 'error'].includes(popupResult)) {
      window.scrollTo({ top: Math.max(0, pending.scrollY || 0), behavior: 'instant' });
      if (pending.returnCart && dialog) dialog.dataset.returnCart = 'true';
    } else if (pending.source === 'inline') {
      const postedForm = document.getElementById(pending.formId);
      const result = postedForm?.querySelector('[data-hd-newsletter-inline-result]');
      if (result && ['success', 'error'].includes(result.dataset.hdNewsletterInlineResult)) {
        const message = result.querySelector('.email-signup__message[tabindex]');
        message?.scrollIntoView({ block: 'nearest', behavior: 'instant' });
        message?.focus({ preventScroll: true });
      }
    }
    try { window.sessionStorage.removeItem(positionKey); } catch {}
  } else if (pending && !fresh) {
    try { window.sessionStorage.removeItem(positionKey); } catch {}
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const isPopup = form.id === 'HdNewsletterForm';
    const isInline = form.hasAttribute('data-hd-newsletter-inline-form');
    if (!isPopup && !isInline) return;

    const wrapper = isInline ? form.closest('.email-signup-block[id]') : null;
    const returnUrl = new URL(location.href);
    returnUrl.searchParams.delete('customer_posted');
    returnUrl.hash = wrapper ? wrapper.id : '';
    let returnInput = form.querySelector('input[name="return_to"]');
    if (!returnInput) {
      returnInput = document.createElement('input');
      returnInput.type = 'hidden';
      returnInput.name = 'return_to';
      form.appendChild(returnInput);
    }
    returnInput.value = returnUrl.pathname + returnUrl.search + returnUrl.hash;
    if (isInline) {
      try { window.sessionStorage.removeItem('her-dad-newsletter-pending'); } catch {}
    }
    write('sessionStorage', positionKey, JSON.stringify({
      at: Date.now(),
      path: location.pathname,
      formId: form.id,
      source: isPopup ? 'popup' : 'inline',
      scrollY: window.scrollY,
      returnCart: isPopup && dialog?.dataset.returnCart === 'true'
    }));
  }, true);
})();
